var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-pick-tabs__container"},[_c('TabsBlack',{attrs:{"tabs":_vm.tabs,"is-pos-device":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }